
<ng-container *ngIf="isLoaded">
  <div class="card mb-3">
    <div class="card-body">
      <div class="pt-4 pb-2">
        <h5 class="card-title text-center pb-0 fs-4">Създаване на услуга за Доставчик</h5>
        <p class="text-center small">Моля, въведете основните данни на Доставчика</p>
      </div>

      <form [formGroup]="Form" class="row g-3 needs-validation" (ngSubmit)="onSubmit()">
        <div class="col-12">
          <label for="title" class="form-label">Име</label>
          <input type="text" formControlName="title" class="form-control" id="title">
        </div>
        <div class="col-12">
          <label for="deliverTaxe" class="form-label">Такса</label>
          <input type="text" formControlName="deliverTaxe" class="form-control" id="deliverTaxe" pattern="^\d+(\.\d{1,2})?$">
        </div>
        <div class="col-12">
          <app-bank-selector (selectedAccount)="onBankAccountSelected($event)" />
        </div>
        <div class="col-12">
          <label for="service" class="form-label">Услуга</label>
          <select formControlName="service" class="form-select">
            <option value="" disabled selected>Изберете една от съществуващите Услуги</option>
            <option *ngFor="let service of services" value="{{service.idService}}">{{service.serviceName}}</option>
          </select>
        </div>
        <div class="col-12">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" formControlName="isActive" id="isActive">
            <label class="form-check-label" for="isActive">Активен</label>
          </div>
        </div>
        <div class="col-12">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" formControlName="staticTax" id="staticTax">
            <label class="form-check-label" for="staticTax">Статична такса (предплатена)</label>
          </div>
          <small class="form-text text-muted">Ако е отметнато, няма да се създава ePayment заявка за тази услуга</small>
        </div>
        <div class="col-12">
          <label for="serviceTermTypeId" class="form-label">Тип срок на услугата</label>
          <select formControlName="serviceTermTypeId" class="form-select" id="serviceTermTypeId">
            <option *ngFor="let termType of serviceTermTypes" [value]="termType.value">
              {{termType.label}}
            </option>
          </select>
          <small class="form-text text-muted">Определя приоритета на услугата за разпределение на заявките</small>
        </div>
        <div class="col-12">
          <label for="sample" class="form-label">Образец</label>
          <input type="text" formControlName="sample" class="form-control" id="sample" maxlength="100">
          <small class="form-text text-muted">Посочете към кой образец се отнася тази конфигурация</small>
        </div>
        <div class="col-12">
          <button class="btn btn-primary w-100" type="submit" [disabled]="!Form.valid">Създай</button>
        </div>
      </form>
    </div>
  </div>

</ng-container>
